/* Native Shopify customer form owns consent, deduplication and submission. */
(() => {
  const setup = root => root.querySelectorAll('[data-hb-newsletter]').forEach(section => {
    const form = section.querySelector('form');
    const status = section.querySelector('[data-newsletter-status]');
    if (!form || !status || form.dataset.newsletterReady) return;
    form.dataset.newsletterReady = 'true';
    const reset = () => { form.removeAttribute('aria-busy'); status.hidden = true; };
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) return;
      // Do not disable the submit control: Shopify may require a CAPTCHA retry.
      setTimeout(() => {
        if (event.defaultPrevented) { reset(); return; }
        form.setAttribute('aria-busy','true'); status.hidden = false;
        status.textContent = 'Submitting your signup… Complete any verification shown to continue.';
      });
    });
    form.addEventListener('input', reset);
    window.addEventListener('pageshow',reset);
  });
  setup(document);
  document.addEventListener('shopify:section:load',event => setup(event.target.parentElement || document));
})();
